import { Button } from '@navent-jobs/ui-kit/components/button'
import styled from 'styled-components'

const textStyles = `
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`

export const CustomButton = styled(Button)`
  padding: 0;
  ${textStyles}
`

export const CustomText = styled.p`
  margin: 0;
  ${textStyles}
`

export const Spacer = styled.div`
  margin-bottom: 16px;
`
